import {
  BtnContainer,
  ButtonRedireccion,
  CruzContainer,
  Header,
  ModalBody,
  RedireccionContainer,
} from "./localStyle";

const OrdenSinAsociar = ({ dissmiss, navigateTo, pedirClave, autorizado }) => {
  const procesoAsociar = () => {
    dissmiss();
    if (autorizado) {
      navigateTo();
    } else {
      setTimeout(() => {
        pedirClave();
      }, 100);
    }
  };

  return (
    <RedireccionContainer>
      <Header>
        <span className="rb16m c-white" style={{ paddingRight: "20px" }}>
          ¡Tenés órdenes médicas disponibles!
        </span>
        <CruzContainer onClick={dissmiss}>
          <div className="line1"></div>
          <div className="line2"></div>
        </CruzContainer>
      </Header>
      <ModalBody>
        <span className="rb16l c-black">
          Para usarlas, necesitás sacar un turno. ¿Querés buscar un turno ahora?
        </span>
        <BtnContainer>
          <ButtonRedireccion
            onClick={dissmiss}
            className="bgc-latex30 rb16m c-white"
          >
            No, más tarde
          </ButtonRedireccion>
          <ButtonRedireccion
            onClick={procesoAsociar}
            className={"bgc-primary pointer rb16m c-white"}
          >
            Sí, buscar turno
          </ButtonRedireccion>
        </BtnContainer>
      </ModalBody>
    </RedireccionContainer>
  );
};

export default OrdenSinAsociar;
